import { render, staticRenderFns } from "./deliveryGoodsDialog.vue?vue&type=template&id=569c9deb"
import script from "./deliveryGoodsDialog.vue?vue&type=script&lang=js"
export * from "./deliveryGoodsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports